'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _FoldersopeningTwoTone = require('./lib/icons/FoldersopeningTwoTone');
  
  
  var _default = _FoldersopeningTwoTone;
  exports.default = _default;
  module.exports = _default;